import {
  FormControl,
  FormControlLabel,
  Radio,
  RadioGroup,
} from "@mui/material";
import TextareaAutosize from "@mui/material/TextareaAutosize";
import { Auth } from "aws-amplify";
import { useEffect, useRef } from "react";
import { FaCheckCircle } from "react-icons/fa";
import { Link } from "react-router-dom";
import { deleteUserFolder } from "../../utils/deleteUserFolder";
import { uploadFileViaPresignedUrl } from "../../utils/uploadFileViaPresignedUrl";

// import CloudUploadIcon from '@mui/icons-material/CloudUpload';
import {
  Box,
  Button,
  CircularProgress,
  Grid,
  Tab,
  Tabs,
  Typography,
} from "@material-ui/core";
import { useState } from "react";
import Swal from "sweetalert2";

export default function DataAnalyticsAgentic({ title, link }) {
  const [csvFile, setCsvFile] = useState(null);
  const [csvload, setcsvload] = useState(false);
  const [pdfdone, setPdfDone] = useState(false);
  const [csvdone, setCsvDone] = useState(false);
  const [error, setError] = useState("");
  const [answerload, setAnswerload] = useState(false);
  const [uploadStatus, setUploadStatus] = useState(false);
  const [selectedModel, setSelectedModel] = useState("gpt-4o");
  const [modeltext, setModelText] = useState("");
  const [userquery, setQuery] = useState("");
  const [userquery1, setQuery1] = useState("");
  const [matchquery, setMatchquery] = useState("");
  const [isCsvUploading, setIsCsvUploading] = useState("");
  const [base64Csv, setBase64Csv] = useState("");
  const [response, setResponse] = useState(null);
  const [tabIndex, setTabIndex] = useState(0);
  const [output, setOutput] = useState("");
  const [formattedOutput, setFormattedOutput] = useState("");
  const handleFileChange = (e) => {
    const file = e.target.files && e.target.files[0];
    setCsvFile(file || null);
    if (file) {
      const reader = new FileReader();
      reader.onload = function (evt) {
        const binaryStr = evt.target?.result;
        if (typeof binaryStr === "string") {
          const b64 = btoa(binaryStr);
          setBase64Csv(b64);
        } else if (binaryStr instanceof ArrayBuffer) {
          const binary = new Uint8Array(binaryStr);
          let str = "";
          for (let i = 0; i < binary.byteLength; i++) {
            str += String.fromCharCode(binary[i]);
          }
          const b64 = btoa(str);
          setBase64Csv(b64);
        }
      };
      reader.readAsBinaryString(file);
    } else {
      setBase64Csv("");
    }
  };

  const timetaken = useRef(0);
  async function signOut() {
    try {
      await Auth.signOut({ global: true });
      window.location.reload();
    } catch (error) {
      // console.log('error signing out: ', error);
    }
  }
  const [genaiaccess, setgenaiaccess] = useState(false);

  useEffect(() => {
    var username = localStorage.getItem(
      "CognitoIdentityServiceProvider.29j70cln6jt05tfejrnii8d5d.LastAuthUser",
    );
    var userdata = localStorage.getItem(
      `CognitoIdentityServiceProvider.29j70cln6jt05tfejrnii8d5d.${username}.userData`,
    );
    if (!userdata) return;
    var jsondata = JSON.parse(userdata);
    let emailAttr = jsondata["UserAttributes"].find(
      (attr) => attr["Name"] === "email",
    );
    let email = emailAttr ? emailAttr["Value"] : "";
    email.includes("genai2244") ? setgenaiaccess(true) : setgenaiaccess(false);
  }, []);

  const [displayText, setDisplayText] = useState("");

  useEffect(() => {
    if (matchquery.length > 0) {
      const formattedTranscript = formatResponse(matchquery);
      let index = 0;
      const intervalId = setInterval(() => {
        setDisplayText((prev) => prev + formattedTranscript[index]);
        index++;
        if (index === formattedTranscript.length) {
          clearInterval(intervalId);
          setMatchquery("");
        }
      }, 1);
    }
  }, [matchquery]);

  useEffect(() => {
    if (output.length > 0) {
      const formattedTranscript = formatResponse(output);
      let index = 0;
      const intervalId = setInterval(() => {
        setFormattedOutput((prev) => prev + formattedTranscript[index]);
        index++;
        if (index === formattedTranscript.length) {
          clearInterval(intervalId);
          setOutput("");
        }
      }, 1);
    }
  }, [output]);

  const formatResponse = (response) => {
    // Replacing markdown-like headers with HTML headers
    const headers = response
      .replace(/(######\s?)(.*?)\n/g, "<h6>$2</h6>")
      .replace(/(#####\s?)(.*?)\n/g, "<h5>$2</h5>")
      .replace(/(####\s?)(.*?)\n/g, "<h4>$2</h4>")
      .replace(/(###\s?)(.*?)\n/g, "<h3>$2</h3>")
      .replace(/(##\s?)(.*?)\n/g, "<h2>$2</h2>")
      .replace(/(#\s?)(.*?)\n/g, "<h1>$2</h1>");

    // Splitting and replacing bold markers
    let responseArray = headers.split("**");
    let newResponse = "";
    for (let i = 0; i < responseArray.length; i++) {
      if (i % 2 === 0) {
        newResponse += responseArray[i];
      } else {
        newResponse += "<b>" + responseArray[i] + "</b>";
      }
    }

    // Replace asterisks and newlines for proper HTML formatting
    newResponse = newResponse.replace(/\*/g, "<br/>");
    newResponse = newResponse.replace(/\n/g, "<br/>");
    newResponse = newResponse.replace(/\\"/g, '"');

    return newResponse;
  };

  useEffect(() => {
    setCsvDone(false);
    setPdfDone(false);
  }, []);

  const handleUpload = async () => {
    if (!csvFile) return;
    setIsCsvUploading(true);
    setcsvload(false);
    setError("");
    var username = localStorage.getItem(
      "CognitoIdentityServiceProvider.29j70cln6jt05tfejrnii8d5d.LastAuthUser",
    );
    try {
      await deleteUserFolder(username);
      await uploadFileViaPresignedUrl(csvFile, username);
      setIsCsvUploading(false);
      setcsvload(true);
      setPdfDone(true);
      setError("File uploaded successfully.");
      setUploadStatus(true);
    } catch (error) {
      console.error("Error uploading file:", error);
      setError(
        "Error while uploading file, please refresh the page and try again.",
      );
      setIsCsvUploading(false);
      setcsvload(false);
      setPdfDone(false);
    }
  };

  const generateAnswers = async () => {
    if (userquery.length > 0 && base64Csv) {
      setAnswerload(true);
      setDisplayText("");
      setMatchquery("");

      var data = JSON.stringify({
        base64_csv: base64Csv,
        user_prompt: userquery,
        cot_user_prompt: userquery1,
      });

      console.log("Selected model:", selectedModel);

      try {
        const response = await fetch(
          "https://zapdh5y32kirltgekic2f3lhia0hyqsr.lambda-url.ap-south-1.on.aws/",
          {
            method: "POST",
            headers: {
              "Content-Type": "application/json",
            },
            body: data,
          },
        );

        if (!response.ok) {
          throw new Error(`HTTP error! status: ${response.status}`);
        }

        const responseData = await response.json();
        console.log("Parsed response:", responseData);
        setResponse(responseData);
        setMatchquery(responseData.explanation);
        setOutput(responseData.output);
        setAnswerload(false);
      } catch (error) {
        console.error("Error parsing response or handling data:", error);
        Swal.fire("An error occurred while processing your request.");
        setAnswerload(false);
      }
    } else if (!userquery) {
      Swal.fire("Please ask a question.");
    } else {
      Swal.fire("Please upload a csv file.");
    }
  };

  return (
    <div>
      <div>
        <img
          id="backgroundmainimageoverlay"
          src="/assets/images/background/g7.mp4"
          alt="background-img"
          style={{
            filter: "opacity(0.2)",
            position: "fixed",
            zIndex: "-3",
            width: "100vw",
            height: "110vh",
            marginTop: "-10vh",
            overflow: "hidden",
          }}
        />
        <img
          style={{ zIndex: "-4" }}
          id="backgroundmainimage"
          src="/assets/images/background/MainBackground.png"
          alt="main-background-img"
        />
      </div>
      <div className="container-fluid navcontent">
        <div className="row justify-content-between">
          <div className="col-auto align-self-end">
            <div>
              <Grid
                style={{ display: "flex", position: "relative", zIndex: "4" }}
              >
                <Link to={link}>
                  <Button variant="contained" component="span" color="primary">
                    Back
                  </Button>
                </Link>
              </Grid>
            </div>
          </div>
          <div
            className="col-auto align-self-end basicheader"
            style={{
              display: "flex",
              flexDirection: "column",
              alignItems: "center",
              justifyContent: "center",
            }}
          >
            <h2 style={{ paddingTop: "10vh !important", fontWeight: "bold" }}>
              {title}
            </h2>
            <p>
              Learn how to transform corporate data into actionable insights
              using GenAI
            </p>
          </div>
          <div className="col-auto align-self-end">
            {/* <Link to="/" style={{paddingRight:"2vw"}}>
                                <Button  variant="contained" color="primary" >Home</Button>
                            </Link> */}
            <Button
              style={{
                backgroundColor: "#ffa502",
                position: "relative",
                zIndex: "4",
              }}
              variant="contained"
              onClick={() => {
                signOut();
              }}
              color="primary"
              component="span"
            >
              Sign Out
            </Button>
          </div>
        </div>
      </div>

      {genaiaccess ? (
        <div>
          <div
            style={{
              flex: "0.3",
              marginBottom: "1rem",
              display: "flex",
              flexDirection: "row",
              justifyContent: "space-evenly",
              width: "fit-content",
              gap: "3rem",
            }}
            className="input-form-chatbot"
          >
            <div className="section-container">
              <h4>
                <strong>File upload window</strong>
              </h4>
              <hr style={{ background: "white" }}></hr>
              <div>
                <p>Upload a CSV file containing data:</p>
                <div className="field">
                  <div style={{ display: "flex", alignItems: "center" }}>
                    <input
                      accept=".csv"
                      id="csv-upload"
                      type="file"
                      onChange={handleFileChange}
                      style={{ display: "none" }}
                    />
                    <label htmlFor="csv-upload">
                      <Button
                        variant="contained"
                        component="span"
                        style={{ width: "130px", marginRight: "1rem" }}
                      >
                        Select CSV
                      </Button>
                    </label>

                    <Button
                      variant="contained"
                      color="primary"
                      component="span"
                      disabled={!csvFile}
                      onClick={handleUpload}
                      style={{
                        marginBottom: "0.5rem",
                      }}
                      startIcon={
                        isCsvUploading && (
                          <CircularProgress color="white" size={20} />
                        )
                      }
                    >
                      Upload CSV
                    </Button>
                    {uploadStatus && (
                      <FaCheckCircle
                        style={{
                          marginLeft: "1rem",
                          color: "green",
                          top: "1rem",
                          marginBottom: "1rem",
                        }}
                        size={25}
                      />
                    )}
                  </div>
                  <Typography variant="body1">
                    <p style={{ wordBreak: "break-all", width: "350px" }}>
                      {csvFile && `Selected file: ${csvFile.name}`}
                    </p>
                  </Typography>
                </div>
              </div>
              <br />
              {console.log(error)}
              <p>{error}</p>
            </div>
            <div className="section-container">
              <h4>
                <strong>Model selection window</strong>
              </h4>
              <hr style={{ background: "white" }}></hr>
              <FormControl>
                <RadioGroup
                  style={{ width: "18rem" }}
                  aria-labelledby="demo-radio-buttons-group-label"
                  defaultValue="female"
                  name="radio-buttons-group"
                  value={selectedModel}
                  onChange={(e) => {
                    if (e.target.value === "gpt-3.5-turbo") {
                      setModelText("gpt-3.5-turbo");
                    } else if (e.target.value === "gpt-4O-mini") {
                      setModelText("gpt-4o-mini");
                    } else if (e.target.value === "gpt-4o") {
                      setModelText("gpt-4o");
                    }
                    setSelectedModel(e.target.value);
                  }}
                >
                  <FormControlLabel
                    value="gpt-4o"
                    control={
                      <Radio
                        sx={{
                          color: "white",
                        }}
                      />
                    }
                    label="GPT 4o"
                  />
                </RadioGroup>
              </FormControl>
            </div>
          </div>
          <div className="input-form-chatbot">
            <div className="section-container">
              <p>Enter Prompt below</p>
              <TextareaAutosize
                id="outlined-basic"
                label="question"
                variant="outlined"
                minRows={1}
                value={userquery}
                onChange={(e) => setQuery(e.target.value)}
                style={{
                  border: "1px solid white",
                  borderRadius: "0.5rem",
                  width: "100%",
                  color: "white",
                  backgroundColor: "transparent",
                  padding: "16.5px 14px", // Adjusted padding to match TextField height
                  fontSize: "16px", // Same font size as TextField
                  lineHeight: "1.4375em", // Match the line height of MUI TextField
                  resize: "none", // Disable manual resizing
                  overflow: "hidden", // Hide scrollbar
                  boxSizing: "border-box", // Ensure padding and border are included in the element's width and height
                }}
              />
              <p style={{ marginTop: "0.5rem" }}>CoT User Prompt</p>
              <TextareaAutosize
                id="outlined-basic"
                label="question"
                variant="outlined"
                minRows={1}
                value={userquery1}
                onChange={(e) => setQuery1(e.target.value)}
                style={{
                  border: "1px solid white",
                  borderRadius: "0.5rem",
                  width: "100%",
                  color: "white",
                  backgroundColor: "transparent",
                  padding: "16.5px 14px", // Adjusted padding to match TextField height
                  fontSize: "16px", // Same font size as TextField
                  lineHeight: "1.4375em", // Match the line height of MUI TextField
                  resize: "none", // Disable manual resizing
                  overflow: "hidden", // Hide scrollbar
                  boxSizing: "border-box", // Ensure padding and border are included in the element's width and height
                }}
              />
              <Button
                style={{ margin: "1rem 0" }}
                variant="contained"
                color="primary"
                onClick={generateAnswers}
                // disabled={!handleTrain}
                startIcon={
                  answerload && <CircularProgress color="white" size={20} />
                }
              >
                Ask
              </Button>
            </div>
          </div>
          <div>
            <div className="input-form-chatbot">
              <div className="section-container" style={{ minHeight: "10rem" }}>
                <h4>
                  <strong>Generated Response</strong>
                </h4>
                <hr style={{ background: "white" }} />

                {answerload && <CircularProgress style={{ color: "white" }} />}

                {!answerload && response?.success ? (
                  <Box
                    sx={{
                      color: "white",
                    }}
                  >
                    <Tabs
                      value={tabIndex}
                      onChange={(e, newIndex) => setTabIndex(newIndex)}
                      textColor="inherit"
                      indicatorColor="secondary"
                    >
                      <Tab label="Explanation" />
                      <Tab label="Output" />
                      <Tab label="Plots" />
                      <Tab label="Deduced Files" />
                    </Tabs>

                    {/* Explanation Tab */}
                    {tabIndex === 0 && displayText.length > 0 && (
                      <Box
                        p={2}
                        sx={{
                          maxHeight: 300,
                          overflowY: "auto",
                          color: "white",
                          fontFamily: "sans-serif",
                          wordWrap: "break-word",
                          whiteSpace: "pre-wrap",
                        }}
                      >
                        <div
                          dangerouslySetInnerHTML={{ __html: displayText }}
                        />
                      </Box>
                    )}

                    {/* Output Tab */}
                    {tabIndex === 1 && formattedOutput.length > 0 && (
                      <Box
                        p={2}
                        sx={{
                          maxHeight: 300,
                          overflowY: "auto",
                          color: "white",
                          fontFamily: "sans-serif",
                          wordWrap: "break-word",
                          whiteSpace: "pre-wrap",
                        }}
                      >
                        <div
                          dangerouslySetInnerHTML={{ __html: formattedOutput }}
                        />
                      </Box>
                    )}

                    {/* Plots Tab */}
                    {tabIndex === 2 && (
                      <Box
                        p={2}
                        style={{
                          maxHeight: 300,
                          overflowY: "auto",
                          display: "grid",
                          gridTemplateColumns: "1fr 1fr",
                          gap: "1rem",
                        }}
                      >
                        {response.plots?.map((plot, idx) => (
                          <div key={idx} style={{ textAlign: "center" }}>
                            <Typography variant="subtitle2">
                              {plot.file_name}
                            </Typography>
                            <img
                              src={`data:image/png;base64,${plot.base64}`}
                              alt={plot.file_name}
                              style={{ maxWidth: "100%" }}
                            />
                          </div>
                        ))}
                      </Box>
                    )}

                    {/* Files Tab */}
                    {tabIndex === 3 && (
                      <Box p={2} sx={{ maxHeight: 300 }}>
                        {response.files?.length > 0 ? (
                          <div
                            style={{
                              display: "flex",
                              flexWrap: "wrap",
                              gap: "1rem",
                            }}
                          >
                            {response.files.map((file, idx) => {
                              const fmt = file.file_name.split(".").pop();
                              const mime =
                                {
                                  csv: "text/csv",
                                  json: "application/json",
                                  xlsx: "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet",
                                  parquet: "application/octet-stream",
                                  xml: "application/xml",
                                  txt: "text/plain",
                                }[fmt] || "application/octet-stream";
                              return (
                                <Button
                                  key={idx}
                                  variant="outlined"
                                  href={`data:${mime};base64,${file.base64}`}
                                  download={file.file_name}
                                >
                                  Download {fmt.toUpperCase()}
                                </Button>
                              );
                            })}
                          </div>
                        ) : (
                          <Typography>No files generated.</Typography>
                        )}
                      </Box>
                    )}
                  </Box>
                ) : (
                  <Typography style={{ color: "white" }}>
                    {response?.error || "Response will be displayed here"}
                  </Typography>
                )}
              </div>
            </div>
          </div>
        </div>
      ) : (
        <h2 style={{ color: "white", textAlign: "center" }}>
          You do not have an access to use this section.
        </h2>
      )}
    </div>
  );
}

export function getFileFormat(fileName) {
  const parts = fileName.split(".");
  return parts.length > 1 ? parts[parts.length - 1].toLowerCase() : "bin";
}

export function getMimeType(format) {
  switch (format.toLowerCase()) {
    case "csv":
      return "text/csv";
    case "json":
      return "application/json";
    case "excel":
    case "xlsx":
      return "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet";
    case "parquet":
      return "application/octet-stream";
    case "xml":
      return "application/xml";
    case "txt":
      return "text/plain";
    default:
      return "application/octet-stream";
  }
}
